import { render, staticRenderFns } from "./InvoicePaymentDataDisplay.vue?vue&type=template&id=ecc62b0a&scoped=true"
import script from "./InvoicePaymentDataDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicePaymentDataDisplay.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoicePaymentDataDisplay.vue?vue&type=style&index=0&id=ecc62b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc62b0a",
  null
  
)

export default component.exports